import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { logout } from '../../services/auth.service';
import './Header.css';

const Header = () => {
  const { user, profile, isAdmin } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-logo">
          <Link to="/map">
            <h1>
              <span className="logo-letter">B</span>rasil
              <span className="logo-letter">O</span>il & Gas
              <span className="logo-letter">M</span>apping
              <span className="logo-letter">P</span>roject
            </h1>
          </Link>
        </div>

        <nav className="header-nav">
          {user ? (
            <>
              <Link to="/map" className="nav-link">Map</Link>
              {isAdmin && (
                <Link to="/admin" className="nav-link">Admin</Link>
              )}
              <div className="user-info">
                <span>{profile?.displayName || user.email}</span>
                {isAdmin && <span className="admin-badge">Admin</span>}
              </div>
              <button onClick={handleLogout} className="btn-logout">
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="nav-link">Login</Link>
              <Link to="/signup" className="nav-link">Sign Up</Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;
